// UserDropdown.js
import { useAuth } from "../../context/AuthContext";
import * as allauth from "../../library/allauth";

export default function UserDropdown({
  isOpen,
  onClose,
  userGroups,
  userFirstName,
  userLastName,
}) {
  const { user, setUser } = useAuth();

  const handleLogout = () => {
    allauth
      .logout()
      .then(() => {
        setUser(null);
      })
      .catch((e) => {
        console.error("Logout error:", e);
      });
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-[9997]"
        onClick={onClose}
      />

      {/* Dropdown Menu */}
      <div
        className="absolute top-full mt-2 right-0  z-[9999] flex flex-col justify-start items-start overflow-hidden rounded-lg bg-white border border-[#f2f4f7]"
        style={{
          boxShadow:
            "0px 12px 16px -4px rgba(16,24,40,0.08), 0px 4px 6px -2px rgba(16,24,40,0.03)",
        }}
      >
        {/* User Info Section */}
        <div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 px-4 py-3">
          <div className="flex justify-start items-center flex-grow-0 flex-shrink-0 w-[193px] relative gap-3">
            {/* User Avatar with Online Indicator */}
            <div className="flex-grow-0 flex-shrink-0 w-10 h-10 relative">
              <div
                className="w-10 h-10 rounded-full bg-[#7c837b] flex items-center justify-center text-white font-medium"
                style={{
                  backgroundImage: user?.avatar
                    ? `url(${user.avatar})`
                    : "none",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                {!user?.avatar &&
                  (userFirstName
                    ? userFirstName[0].toUpperCase()
                    : user?.username
                      ? user.username[0].toUpperCase()
                      : "U")}
              </div>
              <div className="absolute bottom-0 right-0 w-3 h-3 bg-[#12B76A] rounded-full border-2 border-white" />
            </div>

            {/* User Details */}
            <div className="flex flex-col justify-start items-start flex-grow relative">
              <p className="self-stretch flex-grow-0 flex-shrink-0 w-[141px] text-sm font-medium text-left text-[#344054]">
                {userFirstName || user?.last_name
                  ? `${userFirstName || ""} ${userLastName || ""}`.trim()
                  : user?.username || "User"}
              </p>
              <p className="self-stretch flex-grow-0 flex-shrink-0 w-[141px] text-sm text-left text-[#667085]">
                {user?.email || user?.username || "user@example.com"}
              </p>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="self-stretch flex-grow-0 flex-shrink-0 h-px bg-[#f2f4f7]" />

        {/* Menu Items */}
        <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 w-60 relative overflow-hidden bg-white">
          {/* Profile Section */}
          <a
            href="/profile"
            className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative px-4 py-2.5 hover:bg-[#f9fafb] transition-colors"
            onClick={onClose}
          >
            <p className="flex-grow-0 flex-shrink-0 text-sm text-left text-[#344054]">
              View profile
            </p>
          </a>
          <a
            href="/settings"
            className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative px-4 py-2.5 hover:bg-[#f9fafb] transition-colors"
            onClick={onClose}
          >
            <p className="flex-grow-0 flex-shrink-0 text-sm text-left text-[#344054]">
              Settings
            </p>
          </a>

          {/* Divider */}
          <div className="self-stretch flex-grow-0 flex-shrink-0 h-px bg-[#f2f4f7]" />

          {/* Company/Team Section - Only for admin/developer */}
          {(userGroups.includes("xroadz_admin") ||
            userGroups.includes("customer_admin")) && (
            <>
              <a
                href="https://xroadz.ai/"
                className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative px-4 py-2.5 hover:bg-[#f9fafb] transition-colors"
                onClick={onClose}
              >
                <p className="flex-grow-0 flex-shrink-0 text-sm text-left text-[#344054]">
                  Company profile
                </p>
              </a>

              <div className="self-stretch flex-grow-0 flex-shrink-0 h-px bg-[#f2f4f7]" />
            </>
          )}

          {/* Admin Panel - Only for admin */}
          {(userGroups.includes("xroadz_admin") ||
            userGroups.includes("customer_admin")) && (
            <>
              <a
                href="/admin-portal"
                className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative px-4 py-2.5 hover:bg-[#f9fafb] transition-colors"
                onClick={onClose}
              >
                <p className="flex-grow-0 flex-shrink-0 text-sm text-left text-[#344054]">
                  Admin Panel
                </p>
              </a>
              <div className="self-stretch flex-grow-0 flex-shrink-0 h-px bg-[#f2f4f7]" />
            </>
          )}

          {/* Support */}
          <a
            href="/support"
            className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative px-4 py-2.5 hover:bg-[#f9fafb] transition-colors"
            onClick={onClose}
          >
            <p className="flex-grow-0 flex-shrink-0 text-sm text-left text-[#344054]">
              Support
            </p>
          </a>

          {/* Divider */}
          <div className="self-stretch flex-grow-0 flex-shrink-0 h-px bg-[#f2f4f7]" />

          {/* Log out */}
          <button
            onClick={handleLogout}
            className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative px-4 py-2.5 hover:bg-[#f9fafb] transition-colors w-full text-left"
          >
            <p className="flex-grow-0 flex-shrink-0 text-sm text-left text-[#344054]">
              Log out
            </p>
          </button>
        </div>
      </div>
    </>
  );
}
